import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function InvoiceReducer(state = initialState.invoice, action: any) {
  switch (action.type) {
    case types.SAVE_INVOICE_SUCCESS:
      return action.invoice;
    default:
      return state;
  }
}
